S.swiper = {
  config: {
    headline: null,
    data: null,
    type: 'default',
  },
  elements: {
    // wrapper
    $swiperContainer: null,
    $swiperWrapper: null,

    // image wrapper
    $swiperImageContainer: null,
    $swiperImageWrapper: null,

    // slides
    $slides: null,

    // buttons
    $buttonNext: null,
    $buttonPrev: null,
    $buttons: null,

    // pagination
    $swiperPagination: null,
  },

  /** @var {Object} swiper*/
  swiper: null,

  /** @var {Object} stageImageSwiper */
  stageImageSwiper: null,

  /** @var {Object} stageProductSwiper */
  stageProductSwiper: null,

  /** @var {Object} genreSwiper */
  genreSwiper: null,

  /** @var {Object} newsSwiper */
  newsSwiper: null,

  /** @var {Object} peopleSwiper */
  peopleSwiper: null,

  /** @var {Number} neededSlidesPerview */
  neededSlidesPerview: 0,

  init()
  {
  },

  /**
   * if all modules are loaded
   */
  start()
  {
    // save slide lenght
    this.neededSlidesPerview = this.elements.$slides.length;
    console.log(`%c###########################`, 'color: deeppink;');
    console.log(`Line 52 ||  ||`, 'hello', this.neededSlidesPerview);
    console.log(`%c###########################`, 'color: deeppink;');

    if (this.neededSlidesPerview === 1)
    {
      this.$module.addClass('is-single');
    }

    // need to be here to have all instances initialized
    // differ the different modifier
    switch (this.config.type)
    {
      case 'default':
        // default swiper
        this.initSwiper();

        break;
      case 'genre':
        // authors swiper
        this.initGenreSwiper();

        break;
      case 'author':
        // authors swiper
        this.initAuthorsSwiper();

        break;
      case 'stage':
        // stage swiper
        this.initStageSwiper();

        break;
      case 'swiper-news-module':
        // authors swiper
        this.initNewsSwiper();
        this.addMqListener();

        break;
      case 'swiper-series-module':
        // authors swiper
        this.initSwiper();

        break;
      case 'swiper-people-module':
        // authors swiper
        this.initPeopleSwiper();

        break;
      case 'swiper-product-module':
        // authors swiper
        this.initProductSwiper();

        break;
      case 'swiper-partner-module':
        // authors swiper
        this.initPartnerSwiper();

        break;
      case 'text-image-module':
        // text iamge swiper
        this.initTextImageSwiper();

        break;
      default:
        break;
    }
  },

  /**
   * init  swiper
   */
  initSwiper()
  {
    const that = this,
      neededSlides = that.neededSlidesPerview >= 3 ? 3 : (that.neededSlidesPerview >= 2 ? 2 : 1);

    // if there are only two slides shrink the max-width
    if (that.neededSlidesPerview <= 2)
    {
      this.$module.addClass('m-small');
    }

    this.newsSwiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: 1,
      centeredSlides: that.neededSlidesPerview === 1,
      watchSlidesVisibility: true,
      breakpoints: {
        768: {
          slidesPerView: that.neededSlidesPerview >= 2 ? 2 : 1,
        },
        1024: {
          slidesPerView: neededSlides,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className)
        {
          return `<span class="${className}"></span>`;
        },
      },
      on: {
        init()
        {
          // after init remove hidden btn class
          that.removeHiddenClassBtn();
          that.checkIfContentFits();
        },
        resize()
        {
          that.checkIfContentFits(true);
        },
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init news/ swiper
   * @return {string}
   */
  initNewsSwiper()
  {
    const that = this,
      neededSlides = that.neededSlidesPerview >= 3 ? 3 : (that.neededSlidesPerview >= 2 ? 2 : 1);

    let swiperOptions;

    // if there are only two slides shrink the max-width
    if (that.neededSlidesPerview <= 2)
    {
      this.$module.addClass('m-small');
    }

    if (S.mq('tablet').matches)
    {
      swiperOptions = {
        slidesPerView: that.neededSlidesPerview >= 2 ? 2 : 1,
        centeredSlides: that.neededSlidesPerview === 1,
        watchSlidesVisibility: true,
        breakpoints: {
          1024: {
            slidesPerView: neededSlides,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index, className)
          {
            return `<span class="${className}"></span>`;
          },
        },
        on: {
          init()
          {
            // after init remove hidden btn class
            that.removeHiddenClassBtn();
            that.checkIfContentFits();
          },
          resize()
          {
            that.checkIfContentFits(true);
          },
        },
        navigation: {
          nextEl: this.elements.$buttonNext[0],
          prevEl: this.elements.$buttonPrev[0],
        },
      };
    }
    else
    {
      swiperOptions = {
        slidesPerView: 1,
        autoHeight: true,
        watchSlidesVisibility: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index, className)
          {
            return `<span class="${className}"></span>`;
          },
        },
      };
    }

    this.newsSwiper = new Swiper(this.elements.$swiperContainer[0], swiperOptions);

    S.delayed(`news-slider-update-after-destroy-${this.id}`, 200, () =>
    {
      this.newsSwiper.update(true);
    });
  },

  /**
   * init genre list swiper
   */
  initGenreSwiper()
  {
    const that = this,
      neededSlides = that.neededSlidesPerview >= 5 ? 5 : 'auto';

    this.genreSwiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: 'auto',
      centeredSlides: false,
      breakpoints: {
        768: {
          slidesPerView: neededSlides,
        }
      },
      on: {
        init()
        {
          // after init remove hidden btn class
          that.removeHiddenClassBtn();
          that.checkIfContentFits();
        },
        resize()
        {
          that.checkIfContentFits(false);
        },
      },
      pagination: {
        el: this.elements.$swiperPagination[0],
        // clickable: true,
        renderBullet(index, className)
        {
          return `<span class="${className}"></span>`;
        },
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init text image swiper default swiper
   */
  initTextImageSwiper()
  {
    this.swiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className)
        {
          return `<span class="${className}"></span>`;
        },
      },
      on: {
        init: function ()
        {
        },
        resize: () =>
        {
          this.swiper.update();
        }
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init authors swiper
   */
  initAuthorsSwiper()
  {
    const that = this;

    this.swiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: 1,
      centeredSlides: false,
      watchSlidesVisibility: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
      },
      on: {
        init()
        {
          // after init remove hidden btn class
          that.removeHiddenClassBtn();
          that.checkIfContentFits();
        },
        resize()
        {
          that.checkIfContentFits();
        },
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init people module swiper
   */
  initPeopleSwiper()
  {
    const that = this,
      neededSlides = that.neededSlidesPerview >= 3 ? 3 : (that.neededSlidesPerview >= 2 ? 2 : 1);

    // if there are only two slides shrink the max-width
    if (that.neededSlidesPerview === 2)
    {
      this.$module.addClass('m-small');
    }

    this.peopleSwiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: 1,
      watchSlidesVisibility: true,
      breakpoints: {
        768: {
          slidesPerView: that.neededSlidesPerview >= 2 ? 2 : 1,
        },
        1024: {
          slidesPerView: neededSlides,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className)
        {
          return `<span class="${className}"></span>`;
        },
      },
      on: {
        init()
        {
          // after init remove hidden btn class
          that.removeHiddenClassBtn();
          that.checkIfContentFits();
        },
        resize()
        {
          that.checkIfContentFits();
        },
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init partner module swiper
   */
  initPartnerSwiper()
  {
    const that = this;

    let neededSlides;

    switch (this.neededSlidesPerview)
    {
      case 1:
        neededSlides = 1;
        break;
      case 2:
        neededSlides = 2;
        break;
      case 3:
        neededSlides = 3;
        break;
      case 4:
        neededSlides = 4;
        break;
      default:
        neededSlides = 4;
    }

    this.swiper = new Swiper(this.elements.$swiperContainer[0], {
      slidesPerView: neededSlides >= 3 ? 3 : neededSlides,
      centeredSlides: neededSlides === 1,
      watchSlidesVisibility: true,
      loop: neededSlides > 3,
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        1024: {
          slidesPerView: neededSlides,
        }
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet(index, className)
        {
          return `<span class="${className}"></span>`;
        },
      },
      on: {
        init()
        {
          // after init remove hidden btn class
          that.removeHiddenClassBtn();
          that.checkIfContentFits();
        },
        resize()
        {
          that.checkIfContentFits();
        },
      },
      navigation: {
        nextEl: this.elements.$buttonNext[0],
        prevEl: this.elements.$buttonPrev[0],
      },
    });
  },

  /**
   * init proudct module swiper
   */
  initProductSwiper()
  {
    const that = this;

    if (this.neededSlidesPerview > 4)
    {
      this.swiper = new Swiper(this.elements.$swiperContainer[0], {
        slidesPerView: 1,
        centeredSlides: false,
        watchSlidesVisibility: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index, className)
          {
            return `<span class="${className}"></span>`;
          },
        },
        breakpoints: {
          // slides max-width: 300px
          600: {
            slidesPerView: that.neededSlidesPerview === 1 ? 'auto' : 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1160: {
            slidesPerView: 4,
            spaceBetween: 12,
          },
        },
        on: {
          init()
          {
            // after init remove hidden btn class
            that.removeHiddenClassBtn();
            that.checkIfContentFits();
          },
          resize()
          {
            that.checkIfContentFits();
          },
        },
        navigation: {
          nextEl: this.elements.$buttonNext[0],
          prevEl: this.elements.$buttonPrev[0],
        },
      });
    }
    else
    {
      this.swiper = new Swiper(this.elements.$swiperContainer[0], {
        slidesPerView: 1,
        centeredSlides: false,
        watchSlidesVisibility: true,
        breakpoints: {
          // slides max-width: 300px
          600: {
            slidesPerView: that.neededSlidesPerview === 1 ? 'auto' : 2,
          },
          1024: {
            slidesPerView: 'auto',
          },
        },
        on: {
          init()
          {
            // after init remove hidden btn class
            that.removeHiddenClassBtn();
            that.checkIfContentFits();
          },
          resize()
          {
            that.checkIfContentFits();
          },
        },
        navigation: {
          nextEl: this.elements.$buttonNext[0],
          prevEl: this.elements.$buttonPrev[0],
        },
      });
    }
  },

  /**
   * init stage swiper
   */
  initStageSwiper()
  {
    this.stageImageSwiper = new Swiper(this.elements.$swiperContainer[0], {
      // TODO uncomment me out for stage changes (only 1 background-image)
      loop: true,
      speed: 2000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        checkInView: true,
      },
    });

    this.initStageProductSwiper();
  },
  /**
   * init stage swiper
   */
  initStageProductSwiper()
  {
    this.stageProductSwiper = new Swiper(this.elements.$swiperImageContainer[0], {
      loop: true,
      speed: 2000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      // Disable preloading of all images
      preloadImages: false,
      lazy: {
        loadPrevNext: true,
        checkInView: true,
      },
      grabCursor: true,
      watchSlidesProgress: true,
      mousewheelControl: true,
      keyboardControl: true,
      pagination: {
        el: this.elements.$swiperPagination[0],
        type: 'bullets',
        clickable: true,
      },
    });

    this.stageProductSwiper.controller.control = this.stageImageSwiper;
  },

  /**
   * check if slides fit in the wrapper
   * @param handleButtons
   */
  checkIfContentFits(handleButtons = false)
  {

    // get wrapper size
    const wrapperWidth = this.elements.$swiperWrapper.width();

    let slideWidth = 0;

    // calculate width
    this.elements.$slides.each((_, element) =>
    {
      slideWidth += element.offsetWidth;
    });

    if (slideWidth <= wrapperWidth)
    {
      this.elements.$slides.addClass('swiper-no-swiping');
      this.$module.addClass('m-content-fits');

      if (handleButtons)
      {
        this.addHiddenClassBtn();
      }

      return;
    }

    this.elements.$slides.removeClass('swiper-no-swiping');
    this.$module.removeClass('m-content-fits');

    if (handleButtons)
    {
      this.removeHiddenClassBtn();
    }
  },

  /**
   * remove own hidden class from buttons (prevent flickering on init)
   */
  removeHiddenClassBtn()
  {
    this.elements.$buttons.removeClass('is-hidden');
  },

  /**
   * add own hidden class from buttons (prevent flickering on init)
   */
  addHiddenClassBtn()
  {
    this.elements.$buttons.addClass('is-hidden');
  },

  /**
   * only for news slider autoHeight switches from mobile -> tablet/desktop
   */
  addMqListener()
  {
    // add listener
    S.mq('tablet').addListener((e) =>
    {
      if (e.matches)
      {
        // remove mobile class
        if (this.newsSwiper !== null)
        {
          this.newsSwiper.destroy();
          this.initNewsSwiper();
          this.newsSwiper.update();
        }
      }
      else
      {
        // add mobile class
        this.newsSwiper.destroy();
        this.initNewsSwiper();
        this.newsSwiper.update();
      }
    });
  },

  /**
   *
   * @param slides
   * @param maxLength
   * @return {boolean|number}
   */
  neededSlides(slides, maxLength = false)
  {
    const slideLength = slides.length;

    let neededSlides;

    if (maxLength)
    {
      if (slideLength > maxLength)
      {
        return maxLength;
      }
    }

    switch (slideLength)
    {
      case 1:
        neededSlides = 1;
        break;
      case 2:
        neededSlides = 2;
        break;
      case 3:
        neededSlides = 3;
        break;
      case 4:
        neededSlides = 4;
        break;
      default:
        neededSlides = 5;
    }

    return neededSlides;
  },
};
